import type { ISettlementProvider } from './settlement';

export enum WithdrawalStatus {
  pending_approval = 'pending_approval',
  approved = 'approved',
  rejected = 'rejected',
  cancelled = 'cancelled',
}

export enum WithdrawalPaymentStatus {
  pending = 'pending',
  paid = 'paid',
}

export interface IProviderWithdrawalRequest {
  id: number;
  provider_user_id: number;
  amount: number;
  status: WithdrawalStatus;
  payment_status: WithdrawalPaymentStatus;
  requested_at: string;
  paid_at?: string | null;
  admin_notes: string | null;
  rejection_reason: string | null;
  created_at?: string;
  updated_at?: string;
  deleted_at?: string | null;
  provider?: ISettlementProvider | null;
}

export interface IPaginatedWithdrawals {
  total_count: number;
  items: IProviderWithdrawalRequest[];
}
